/**
 * Hydrates "You may also like" — same type + gender, in-stock only, up to section limit.
 * Scores candidates per product (vendor, tags, title) so each PDP gets a unique rail.
 */
(function () {
  var JSON_LIMIT = 250;
  var MIN_PRODUCTS = 10;

  function shopBaseUrl() {
    var r =
      (typeof window !== 'undefined' && window.routes && window.routes.root_url) ||
      (typeof window !== 'undefined' &&
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      '';
    r = String(r || '').trim();
    if (!r) {
      return typeof window !== 'undefined' ? window.location.origin + '/' : '/';
    }
    return r.endsWith('/') ? r : r + '/';
  }

  function collectionProductsJsonUrl(handle, page) {
    var path =
      'collections/' +
      encodeURIComponent(handle) +
      '/products.json?limit=' +
      JSON_LIMIT +
      '&page=' +
      page +
      '&sort_by=best-selling';
    var base = shopBaseUrl();
    try {
      return new URL(path, base).href;
    } catch (_e) {
      return path.indexOf('/') === 0 ? path : '/' + path;
    }
  }

  function fetchAllProducts(handle) {
    var all = [];
    var page = 1;

    function next() {
      return fetch(collectionProductsJsonUrl(handle, page))
        .then(function (r) {
          if (!r.ok) throw new Error('products.json ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var batch = data.products || [];
          for (var i = 0; i < batch.length; i++) all.push(batch[i]);
          if (batch.length < JSON_LIMIT) return all;
          page += 1;
          return next();
        });
    }

    return next();
  }

  function handleize(str) {
    return String(str || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function productTypeKey(p) {
    return handleize((p && (p.product_type || p.type)) || '');
  }

  function productTagsJoined(p) {
    var tags = p && p.tags;
    if (Array.isArray(tags)) {
      return tags
        .map(function (t) {
          return String(t || '').trim();
        })
        .join('|')
        .toLowerCase();
    }
    return String(tags || '')
      .split(',')
      .map(function (t) {
        return t.trim();
      })
      .join('|')
      .toLowerCase();
  }

  function productGenderKey(p) {
    if (!p) return '';
    var tagsJoined = productTagsJoined(p);
    var typeLc = String((p.product_type || p.type) || '')
      .toLowerCase()
      .trim();
    var titleLc = String(p.title || '')
      .toLowerCase()
      .trim();
    var haystack = tagsJoined + '|' + typeLc + '|' + titleLc;

    var hasMen = false;
    var hasWomen = false;

    var menTagExact = /(^|\|)(men|man|male|mens|men's|boy|boys)(\||$)/i;
    var womenTagExact = /(^|\|)(women|woman|female|womens|women's|lady|ladies|girl|girls)(\||$)/i;

    if (
      tagsJoined.indexOf('gender: men') !== -1 ||
      tagsJoined.indexOf('gender: male') !== -1 ||
      tagsJoined.indexOf('target gender: men') !== -1 ||
      tagsJoined.indexOf('target gender: male') !== -1 ||
      tagsJoined.indexOf('gender:men') !== -1 ||
      tagsJoined.indexOf('gender:male') !== -1
    ) {
      hasMen = true;
    }
    if (
      tagsJoined.indexOf('gender: women') !== -1 ||
      tagsJoined.indexOf('gender: female') !== -1 ||
      tagsJoined.indexOf('target gender: women') !== -1 ||
      tagsJoined.indexOf('target gender: female') !== -1 ||
      tagsJoined.indexOf('gender:women') !== -1 ||
      tagsJoined.indexOf('gender:female') !== -1
    ) {
      hasWomen = true;
    }

    if (!hasMen && menTagExact.test(tagsJoined)) hasMen = true;
    if (!hasWomen && womenTagExact.test(tagsJoined)) hasWomen = true;

    if (!hasMen && !hasWomen) {
      if (/\b(men|mens|male)\b/.test(haystack)) hasMen = true;
      if (/\b(women|womens|woman|female|ladies|lady)\b/.test(haystack)) hasWomen = true;
    }

    if (hasMen && !hasWomen) return 'men';
    if (hasWomen && !hasMen) return 'women';
    return '';
  }

  function genderMatches(sourceGender, candidateGender) {
    if (!sourceGender) return true;
    if (!candidateGender) return true;
    return sourceGender === candidateGender;
  }

  function productVerticalKey(p) {
    if (!p) return 'apparel';
    var tagsJoined = productTagsJoined(p);
    var typeLc = String((p.product_type || p.type) || '')
      .toLowerCase()
      .trim();
    var vendorLc = String((p.vendor) || '')
      .toLowerCase()
      .trim();

    if (p.template_suffix === 'luxury') return 'beauty';

    if (/(^|\|)luxury(\||$)/i.test(tagsJoined)) return 'beauty';
    if (vendorLc.indexOf('beauty') !== -1) return 'beauty';

    var beautyType =
      /perfume|cosmetic|beauty|fragrance|skincare|makeup|make-up|lipstick|serum|cologne|moistur|cleanser|toner|foundation|mascara|eyeliner|deodorant|shampoo|conditioner|body mist|eau de|nail polish|concealer|sunscreen/;
    if (beautyType.test(typeLc)) return 'beauty';

    if (
      tagsJoined.indexOf('perfume') !== -1 ||
      tagsJoined.indexOf('cosmetic') !== -1 ||
      tagsJoined.indexOf('fragrance') !== -1 ||
      tagsJoined.indexOf('skincare') !== -1 ||
      tagsJoined.indexOf('makeup') !== -1 ||
      /(^|\|)beauty(\||$)/i.test(tagsJoined)
    ) {
      return 'beauty';
    }

    return 'apparel';
  }

  function productTypeFamilyKey(p) {
    if (!p) return 'other';
    var typeKey = productTypeKey(p);
    var typeLc = String((p.product_type || p.type) || '')
      .toLowerCase()
      .trim();

    function hasAny(keywords) {
      for (var i = 0; i < keywords.length; i++) {
        var kw = keywords[i];
        if (typeKey.indexOf(kw) !== -1 || typeLc.indexOf(kw.replace(/-/g, ' ')) !== -1) return true;
      }
      return false;
    }

    if (hasAny(['perfume', 'fragrance', 'cologne', 'eau-de', 'body-mist'])) return 'fragrance';
    if (hasAny(['lipstick', 'lip', 'mascara', 'eyeliner', 'foundation', 'concealer', 'blush', 'highlighter', 'makeup', 'make-up', 'primer'])) return 'makeup';
    if (hasAny(['serum', 'moistur', 'cleanser', 'toner', 'sunscreen', 'skincare', 'face-mask', 'cream', 'lotion'])) return 'skincare';
    if (hasAny(['shampoo', 'conditioner', 'hair'])) return 'haircare';
    if (hasAny(['shirt', 'tee', 't-shirt', 'top', 'blouse', 'kurta', 'tunic', 'polo', 'tank', 'crop', 'camisole', 'vest'])) return 'tops';
    if (hasAny(['trouser', 'pant', 'jean', 'denim', 'short', 'skirt', 'legging', 'jogger', 'chino', 'cargo'])) return 'bottoms';
    if (hasAny(['dress', 'gown', 'jumpsuit', 'romper', 'co-ord', 'coord'])) return 'dresses';
    if (hasAny(['jacket', 'coat', 'blazer', 'hoodie', 'sweatshirt', 'sweater', 'cardigan', 'outerwear', 'shrug', 'bomber', 'windcheater'])) return 'outerwear';
    if (hasAny(['shoe', 'sneaker', 'sandal', 'heel', 'boot', 'loafer', 'footwear', 'slipper', 'flat'])) return 'footwear';
    if (hasAny(['bag', 'wallet', 'belt', 'watch', 'sunglass', 'hat', 'scarf', 'jewel', 'accessor', 'cap', 'sock', 'tie'])) return 'accessories';
    return 'other';
  }

  function verticalMatches(sourceVertical, candidateVertical) {
    return (sourceVertical || 'apparel') === (candidateVertical || 'apparel');
  }

  function familyMatches(sourceFamily, candidateFamily) {
    if (!sourceFamily || sourceFamily === 'other') return false;
    return sourceFamily === candidateFamily;
  }

  function variantIsPurchasable(v) {
    if (!v) return false;
    if (v.inventory_policy === 'continue') return true;
    var qty = v.inventory_quantity;
    if (qty != null && qty !== '' && Number(qty) > 0) return true;
    var a = v.available;
    if (a === true || a === 1) return true;
    if (typeof a === 'string') {
      var s = a.toLowerCase();
      if (s === 'true' || s === '1') return true;
      if (s === 'false' || s === '0') return false;
    }
    if (a === false || a === 0) return false;
    if (!v.inventory_management) return true;
    return false;
  }

  function productAvailable(p) {
    if (!p) return false;
    var vs = p.variants || [];
    var i;
    for (i = 0; i < vs.length; i++) {
      if (variantIsPurchasable(vs[i])) return true;
    }
    if (p.available === true || p.available === 1) return true;
    if (typeof p.available === 'string') {
      var a = p.available.toLowerCase();
      if (a === 'true' || a === '1') return true;
    }
    if (vs.length > 0) return false;
    if (p.available === false || p.available === 0) return false;
    return true;
  }

  function hashString(str) {
    var h = 0;
    var s = String(str || '');
    for (var i = 0; i < s.length; i++) {
      h = (h * 31 + s.charCodeAt(i)) | 0;
    }
    return Math.abs(h);
  }

  var GENERIC_TAGS = {
    men: true,
    women: true,
    man: true,
    woman: true,
    male: true,
    female: true,
    mens: true,
    womens: true,
    "men's": true,
    "women's": true,
    boy: true,
    boys: true,
    girl: true,
    girls: true,
    lady: true,
    ladies: true,
    from_249: true,
    luxury: true,
    unisex: true,
  };

  function tagList(p) {
    var joined = productTagsJoined(p);
    if (!joined) return [];
    return joined.split('|').filter(Boolean);
  }

  function buildSourceProduct(products, opts) {
    for (var i = 0; i < products.length; i++) {
      if (products[i].id === opts.productId) return products[i];
    }
    return {
      id: opts.productId,
      vendor: opts.vendor || '',
      tags: opts.tagsRaw || '',
      title: opts.title || '',
      product_type: opts.typeRaw || opts.typeKey || '',
      type: opts.typeRaw || opts.typeKey || '',
    };
  }

  function relevanceScore(source, candidate, catalogIndex, opts) {
    var score = 0;
    var srcVendor = handleize(source.vendor || '');
    var candVendor = handleize(candidate.vendor || '');
    if (srcVendor && srcVendor === candVendor) score += 300;

    var srcTags = tagList(source);
    var candTagSet = Object.create(null);
    tagList(candidate).forEach(function (tag) {
      candTagSet[tag] = true;
    });
    var sharedTags = 0;
    for (var i = 0; i < srcTags.length; i++) {
      var tag = srcTags[i];
      if (GENERIC_TAGS[tag]) continue;
      if (candTagSet[tag]) {
        sharedTags += 1;
        score += 25;
      }
    }

    var srcWords = String(source.title || '')
      .toLowerCase()
      .split(/\W+/)
      .filter(function (word) {
        return word.length > 3;
      });
    var candTitle = String(candidate.title || '').toLowerCase();
    for (var j = 0; j < srcWords.length; j++) {
      if (candTitle.indexOf(srcWords[j]) !== -1) score += 8;
    }

    score += (hashString(String(source.id) + ':' + String(candidate.id)) % 1000) / 1000;
    score += Math.max(0, 40 - catalogIndex * 0.04);

    if (srcVendor !== candVendor && sharedTags === 0) {
      score -= catalogIndex * 1.5;
    }

    if (opts.typeKey && productTypeKey(candidate) === opts.typeKey) {
      score += 120;
    } else if (familyMatches(opts.familyKey, productTypeFamilyKey(candidate))) {
      score += 40;
    }

    return score;
  }

  function candidatePassesBase(p, opts, seenHandle) {
    if (!p || !p.handle || seenHandle[p.handle]) return false;
    if (opts.productId && p.id === opts.productId) return false;
    if (!productAvailable(p)) return false;
    if (!genderMatches(opts.genderKey, productGenderKey(p))) return false;
    if (!verticalMatches(opts.verticalKey, productVerticalKey(p))) return false;
    return true;
  }

  function pickRecommendationHandles(products, opts) {
    var limit = opts.limit;
    var typeKey = opts.typeKey;
    var familyKey = opts.familyKey || 'other';
    var source = buildSourceProduct(products, opts);
    var candidates = [];
    var seenHandle = Object.create(null);

    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      if (!candidatePassesBase(p, opts, seenHandle)) continue;

      var pType = productTypeKey(p);
      var isSameType = typeKey && pType === typeKey;
      var isSameFamily =
        !isSameType &&
        familyKey &&
        familyKey !== 'other' &&
        familyMatches(familyKey, productTypeFamilyKey(p));

      if (!isSameType && !isSameFamily) continue;

      candidates.push({
        p: p,
        score: relevanceScore(source, p, i, opts),
      });
    }

    candidates.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return a.p.id - b.p.id;
    });

    var handles = [];
    for (var c = 0; c < candidates.length && handles.length < limit; c++) {
      var handle = candidates[c].p.handle;
      if (seenHandle[handle]) continue;
      seenHandle[handle] = true;
      handles.push(handle);
    }

    return handles;
  }

  function wakeSlider(root) {
    var sliderComponent = root.querySelector('slider-component');
    if (!sliderComponent) return;
    if (typeof sliderComponent.syncScrollPort === 'function') {
      sliderComponent.syncScrollPort();
    }
    if (typeof sliderComponent.initPages === 'function') {
      sliderComponent.initPages();
    }
    if (typeof sliderComponent.update === 'function') {
      sliderComponent.update();
    }
  }

  function hydrate(root, handles) {
    if (!handles.length) return Promise.resolve();
    var sectionId = root.dataset.sectionId;
    var params = new URLSearchParams();
    params.set('section_id', sectionId);
    params.set('skipp_type_rec_handles', handles.join(','));
    var url = window.location.pathname + '?' + params.toString();
    return fetch(url)
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-skipp-type-recs]');
        if (!fresh) return;
        var slider = fresh.querySelector('[data-skipp-pdp-rail-slider]');
        if (!slider || !slider.querySelector('.product-grid .grid__item')) return;
        var heading = root.querySelector('.related-products__heading');
        if (!heading && fresh.querySelector('.related-products__heading')) {
          root.insertAdjacentHTML('afterbegin', fresh.querySelector('.related-products__heading').outerHTML);
        }
        var existing = root.querySelector('[data-skipp-pdp-rail-slider]');
        if (existing) {
          existing.replaceWith(slider);
        } else {
          root.appendChild(slider);
        }
        root.dataset.skippTypeRecsReady = '1';
        wakeSlider(root);
        document.dispatchEvent(new CustomEvent('skipp:collection-delivery-split'));
      });
  }

  function init(root) {
    if (!root || root.dataset.skippTypeRecsReady === '1') return;

    var handle = root.dataset.catalogHandle || 'all';
    var typeKey = handleize(root.dataset.productType);
    var genderKey = String(root.dataset.productGender || '').trim();
    var verticalKey = String(root.dataset.productVertical || 'apparel').trim() || 'apparel';
    var familyKey = String(root.dataset.productTypeFamily || 'other').trim() || 'other';
    var productId = parseInt(root.dataset.productId, 10);
    var sectionId = root.dataset.sectionId;
    var limit = parseInt(root.dataset.limit, 10) || MIN_PRODUCTS;
    if (limit < MIN_PRODUCTS) limit = MIN_PRODUCTS;
    var cardCount = root.querySelectorAll('.product-grid .grid__item').length;

    if (!sectionId) return;

    fetchAllProducts(handle)
      .then(function (products) {
        var handles = pickRecommendationHandles(products, {
          limit: limit,
          productId: productId,
          typeKey: typeKey,
          typeRaw: root.dataset.productType || '',
          genderKey: genderKey,
          verticalKey: verticalKey,
          familyKey: familyKey,
          vendor: root.dataset.productVendor || '',
          tagsRaw: root.dataset.productTags || '',
          title: root.dataset.productTitle || '',
        });
        if (!handles.length) {
          if (cardCount > 0) wakeSlider(root);
          return;
        }
        return hydrate(root, handles);
      })
      .catch(function () {
        if (cardCount > 0) wakeSlider(root);
      });
  }

  function boot() {
    document.querySelectorAll('[data-skipp-type-recs]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
